export default "__VITE_PUBLIC_ASSET__7bad0187__"